module.exports = __webpack_public_path__ + "e06c0b7611aa7df771aa968846e2ee64.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-26.png
// module id = 1777
// module chunks = 0